
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 230.4 281.8"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#FFF","d":"M41.9 65.9c.9 8.1 9.6 27.2 16.1 31.5s37.7-8.1 25.9-31.3-43-8.3-42-.2zM71.4 25c39.1 3.5 48.5 39.8 43.1 64.6s-41.6 37.1-41.6 37.1 14 19.7 18.9 30.9-28.5 30.8-37.8 16S9.6 102.3 1.1 78.7 32.2 21.4 71.4 25zm37.2-11.4c-1.9-9.9 32.6-15.4 34.9-8.3s8.2 40.1 8.2 40.1l27.4-42.8c5.3-7.3 29.1 1.4 30.6 15.3S179 57.2 179 57.2s41.1 25.2 49.5 32.6-13 36.5-21.7 31.8-43.7-34.7-43.7-34.7l7.7 36.3c1.4 8.1-32.9 14.9-35.6 6.6S110.5 23.5 108.6 13.6zM16.5 211.7H214v.4H16.5zM67 269.5v12.3h-8.5v-36.7h12.9c2.3-.1 4.5.3 6.7.9 1.7.5 3.2 1.4 4.6 2.5 1.2 1 2.1 2.3 2.7 3.8.6 1.5.9 3.1.9 4.7 0 1.7-.3 3.4-.9 5-.6 1.5-1.5 2.9-2.7 3.9-1.3 1.2-2.9 2-4.6 2.5-2.1.7-4.4 1-6.6.9l-4.5.2zm0-6.4h4.4c2.2 0 3.8-.5 4.8-1.6 1-1.2 1.6-2.8 1.5-4.4 0-.8-.1-1.6-.4-2.3-.2-.7-.6-1.3-1.1-1.8-.6-.5-1.2-.9-1.9-1.1-.9-.3-1.8-.4-2.8-.4H67v11.6zM97.9 275h13.6v6.8H89.4v-36.7h8.5V275z"}}),_c('path',{attrs:{"fill":"#FFF","d":"M148.4 281.8h-6.6c-.6 0-1.3-.2-1.8-.5s-.8-.8-1-1.3l-2.2-6.4h-13.9l-2.2 6.4c-.2.5-.5 1-1 1.3-.5.4-1.1.6-1.8.6h-6.6l14.2-36.7h8.7l14.2 36.6zm-23.6-14h10l-3.4-10c-.2-.6-.5-1.4-.8-2.3s-.6-1.8-.9-2.8c-.3 1-.6 2-.8 2.8s-.6 1.6-.8 2.3l-3.3 10zM163.3 267.9v13.9h-8.5v-13.9l-13.3-22.7h7.5c.6 0 1.3.1 1.8.5.4.4.8.8 1.1 1.3l5.2 10.7c.4.9.8 1.6 1.2 2.4s.7 1.4.9 2.1c.3-.7.6-1.5.9-2.1.4-.7.7-1.5 1.1-2.3l5.2-10.7c.1-.2.3-.5.4-.6l.6-.6c.2-.2.5-.3.8-.4.3-.1.7-.2 1-.2h7.6l-13.5 22.6z"}})])
          )
        }
      }
    